import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料今日</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-secondary-200/90 max-w-md">
              把今日热点事件与热门话题聚合好，热点盘点、热议焦点都放在同一页。想快速知道今天哪个瓜被拿得多，点进来扫一遍就能看到值得吃的几件事。
            </p>
            <p className="mt-4 text-xs leading-6 text-secondary-300/80 max-w-md">
              站内内容为公开网络讨论的整理与盘点，仅代表网友观点，不构成事实认定。请理性阅读，独立判断。
            </p>
          </div>

          <nav aria-label="站内导航">
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-secondary-200/90 hover:text-accent-300 transition-colors">
                  今日首页
                </Link>
              </li>
              <li>
                <Link to="/ranking" className="text-secondary-200/90 hover:text-accent-300 transition-colors">
                  热搜榜单
                </Link>
              </li>
              <li>
                <Link to="/#topics" className="text-secondary-200/90 hover:text-accent-300 transition-colors">
                  话题分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200/90 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-secondary-200/90">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </span>
                contact@heiliao-today.example
              </li>
              <li className="flex items-center gap-2 text-secondary-200/90">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-time-line" aria-hidden="true"></i>
                </span>
                每日 10:00 更新榜单
              </li>
              <li className="flex items-center gap-2 text-secondary-200/90">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-shield-check-line" aria-hidden="true"></i>
                </span>
                内容纠错优先处理
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300/80">© 2026 黑料今日 · 娱乐热点聚合与盘点</p>
          <p className="text-xs text-secondary-300/80">拒绝未经核实的内容，支持理性讨论</p>
        </div>
      </div>
    </footer>
  );
}